import { render, staticRenderFns } from "./Environmentalcode.vue?vue&type=template&id=31e9abdb&scoped=true&"
import script from "./Environmentalcode.vue?vue&type=script&lang=js&"
export * from "./Environmentalcode.vue?vue&type=script&lang=js&"
import style0 from "./Environmentalcode.vue?vue&type=style&index=0&id=31e9abdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e9abdb",
  null
  
)

export default component.exports